import { setPageDetails, pushEventInfo } from './analytics';
export var setBulkAddPageAnalytics = function () {
    var page = {
        pageInfo: {
            pageName: 'account>add manage users>bulk add',
            pageType: 'maml:account management',
        },
        category: {
            primaryCategory: 'account',
            subCategory1: 'account>add manage users',
            subCategory2: 'account>add manage users>bulk add',
        },
    };
    setPageDetails(page);
};
export var setProfileAccountClosureLinksAnalytics = function (profilePageAccountClosureLink) {
    var thdAnalyticsEvent = {
        category: {
            primaryCategory: 'stash',
        },
        eventInfo: {
            eventName: 'my account settings',
        },
        eventMode: 'stash',
        myAccount: {
            settings: "profile: ".concat(profilePageAccountClosureLink),
        },
    };
    pushEventInfo(thdAnalyticsEvent);
};
